<template>
  <div class="friendPage">
    <div class="txtBox">
      <img src="@/assets/img/friend/txt0.png">
      <div v-if="!shareFinish" class="shareFinishBox">
        <!-- 邀請好友 -->
        <img src="../assets/img/friend/txt1.png">
        <v-btn @click="shareMsg(); $addTags(tags.shareMsg,null,null,null)">
          <img src="../assets/img/friend/getFriend.svg">
        </v-btn>
      </div>
      <div v-if="shareFinish" class="shareFinishBox">
        <!-- 已經邀請好友 -->
        <img v-if="shareFinish" src="../assets/img/friend/txt2.png">
        <a href="#" @click="$addTags(tags.goHome,null,null,{path: '/'} )"><img
            src="../assets/img/friend/goHome.png"></a>
        <!--<router-link to="/fromPage"><img src="../assets/img/friend/goHome.png"></router-link>-->
      </div>
      <a href="#" @click="goAeSHOP(), $addTags(tags.goAeSHOP,null,null,null)" class="toAeShop">
        <img src="../assets/img/friend/toAeShop.svg"></a>
    </div>
    <popup :popupIconType="popupIconType" :popupItem="popupItem" :prize="prize" :canSendTime="canSendTime" v-if="dialog"
      @popupStatus="dialog=false, shareFinish=true " @changeAeMember="changeAeMember" />
  </div>
</template>

<script>
  import axios from "axios";
  import swal from 'sweetalert2'
  import liff from '@line/liff';
  import popup from '../components/popup'
  export default {
    name: 'friendPage',
    components: {
      popup,
    },
    props: ['userInfo'],
    data() {
      return {
        dialog: false,
        popupIconType: '',
        popupItem: '',
        prize: '',
        shareFinish: false,
        canSendTime: '',
        shareMsgSuccess: false,
        tags: {
          "shareMsg": "D8B96E52C9AF475791AACB96CE381E99",
          "goAeSHOP": "5CB4D8624F744A24B4A47517C6B79FCA",
          "goHome": "8D0B2A4202D64B92A941ADF2BE09D91F"
        }
      }
    },
    methods: {
      // 邀請line好友
      shareMsg() {
        var me = this;
        var isDev = /(192.168|localhost|thor.iprefer|hulk.iprefer)/.test(window.location.href);
        const oaUrl = isDev ? 'https://liff.line.me/1656433734-Deg8qRqg' : 'https://liff.line.me/1655166006-PrwQEl4w';
        if (!liff.isApiAvailable("shareTargetPicker")) {
          swal
            .fire({
              icon: "error",
              title: "您的Line版本不支援此功能",
              text: "請嘗試更新Line app後，再次使用此功能",
            });
        } else {
          swal.fire({
            allowOutsideClick: false
          });
          swal.showLoading();
          liff.shareTargetPicker([{
              "type": "text",
              "text": "快跟我和春風貓一起好好生活\n🥰🥰現在加入並成功邀請好友，送免費LINE POINTS🙌 \n\n【春風貓好好生活節🐱】\n📆 即日起至2022/12/01止\n成為春風LINE好友，並成功邀請其他好友加入，即可獲得10點LINE POINTS🙌 （每人限領1次，限量200名，送完為止）\n🛒活動期間內，單筆購買春風全系列商品滿199元，參加登錄發票還能抽✨ iPhone14 ✨等多項好禮！\n\n👇點擊下方圖片立即加入👇",
              "wrap": true
            },
            {
              "type": "flex",
              "altText": "春風貓好好生活節，現在加入並成功邀請好友，送免費LINE POINTS",
              "contents": {
                "type": "bubble",
                "size": "giga",
                "hero": {
                  "type": "image",
                  "url": me.$apiUrl + "/sharing.jpg",
                  "size": "full",
                  "aspectRatio": "1:1",
                  "aspectMode": "cover",
                  "action": {
                    "type": "uri",
                    "uri": `${oaUrl}?inviteCode=${this.userInfo.inviteCode}#`
                  }
                }
              }
            }
          ]).then(function (res) {
            if (res) {
              // succeeded in sending a message through TargetPicker
              // console.log(`[${res.status}] Message sent!`)
              me.shareMsgSuccess = true
            } else {
              const [majorVer, minorVer] = (liff.getLineVersion() || "").split('.');
              if (parseInt(majorVer) == 10 && parseInt(minorVer) < 11) {
                // LINE 10.3.0 - 10.10.0
                // Old LINE will access here regardless of user's action
                // TargetPicker 至少已打開。是否成功發送消息不清楚
                me.shareMsgSuccess = true
              } else {
                // LINE 10.11.0 -
                // sending message canceled
                // console.log('TargetPicker was closed!')
                // 取消分享
                me.shareMsgSuccess = false
              }
            }

            if (me.shareMsgSuccess) {
              // 已成功分享好友訊息
              if (me.userInfo.isAeMember) {
                 // 是isAeMember會員
                me.shareFinish = true
              } else {
                me.seePopUp('Friend')
                // 取得驗證碼的倒數秒數
                me.getCanSendTime()
              }
            } else {
              // user取消分享
              // alert("")
            }
          }).catch(function (error) {
            // something went wrong before sending a message
            console.log(error);
            alert('系統忙碌中，請稍後再試 !!');
          }).finally(() => {
            swal.close();
          });
        }
      },
      // 取得驗證碼的倒數秒數
      getCanSendTime() {
        var me = this;
        me.url = '/Liff/GetData_SmsCanSendTime/54CF6E71502D44198838C6C21DA43F0A'
        var config = {
          method: "get",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
        }
        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                // 剩餘秒數
                me.canSendTime = data.data
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
      // 在line liff裡開網頁
      goAeSHOP() {
        liff.openWindow({
          url: "https://pse.is/4f5ggc",
          external: false,
        });
      },
      seePopUp(val) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
      },
      changeAeMember(){
        this.$emit("changeAeMember", true)
      }
    }
  }
</script>
<style lang="scss">
  .friendPage {
    height: calc(100vh - 56px);
    background-size: cover;
    background-position: center;
    background-image: url(../assets/img/friend/bg.png);
    display: flex;
    justify-content: center;
    align-items: center;

    .txtBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .shareFinishBox {
        text-align: center;
      }

      img {
        margin-bottom: 20px;

        &:nth-child(-n+2) {
          width: 100%;
        }
      }
    }
  }
</style>